import { gql, useQuery } from '@apollo/client'

import {
  ArtistSearchQuery,
  ArtistSearchQueryVariables,
  CurrentUserFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { data } = useQuery<ArtistSearchQuery, ArtistSearchQueryVariables>(
    QUERY
  )

  return {
    state: {
      user: data?.user ?? null,
    },
    actions: {},
  }
})

const QUERY = gql`
  query ArtistSearch {
    user {
      ...CurrentUser
    }
  }
  ${CurrentUserFragmentDoc}
`
